import React from 'react'

const Token: React.FC<JSX.IntrinsicElements['span']> = ({
  children,
  className,
  ...props
}) => (
  <span
    className={`${className} cursor-pointer select-none rounded-md px-1 py-1 transition ease-in-out hover:bg-slate-300 hover:opacity-80`}
    {...props}
  >
    {children}
  </span>
)

export default Token
